import { render } from "./TheProducerLine.vue?vue&type=template&id=7354a004"
import script from "./TheProducerLine.vue?vue&type=script&lang=js"
export * from "./TheProducerLine.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__